export enum StatusArrived {
    Arrived = 6,
    Loading = 7,
    Cleaning = 15,
    ReadyForLoading = 16,
    CleaningCallInSend = 17,
    LoadingCallInSend = 21,
    DroppedEmpty = 22
}